import script from "./localeSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./localeSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./localeSwitcher.vue?vue&type=style&index=0&id=5714bf26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5714bf26"]])

export default __exports__